// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"40c95963","94":"c5299106","193":"f6c13bd7","216":"5d46bf8c","475":"dcf7bb1a","669":"670e7a22","739":"d305a49f","773":"6a3c68c3","925":"4f2fe926","986":"1bb62644"}[chunkId] + ".chunk.js";
};